<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('product_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-purse</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
      <template slot="right" v-if="item">
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-product-show">
      <v-row>
        <v-col md="3" v-if="item">
          <ImageView :item="item" filter="250x250" :edit="false" />
        </v-col>
      <v-col md="9">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('qualitycheck.product.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('qualitycheck.product.customer') }}</strong></td>
              <td>
                                  <span v-if="item['customer']"> {{ item['customer'].name }} </span>
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('qualitycheck.product.statu') }}</strong></td>
              <td>
                          <span v-if="item['status']">  {{ item['status'].name }} </span>
              </td>

              <td><strong>{{ $t('qualitycheck.product.location') }}</strong></td>
              <td>
                                    {{ item['location'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('qualitycheck.product.type') }}</strong></td>
              <td>
                                    {{ item['type'] }}
              </td>
              <td><strong>{{ $t('qualitycheck.product.typevalue') }}</strong></td>
              <td>
                                    {{ item['valueType'] }}
              </td>

            </tr>
            <tr v-if="item['machine']">
              <td><strong>{{ $t('qualitycheck.product.productchildren') }}</strong></td>
              <td>
                  <ul v-for="(object, attr) in item['products']" :key="attr">
                    <li>
                      <span ><router-link class="routerLink" :to="{ name: 'ProductShow', params: { id:  object['@id']}  }">{{ object.name }}</router-link></span>

                    </li>
                  </ul>
              </td>
              <td></td>
              <td>

              </td>
            </tr>


            <tr v-else>
              <td><strong>{{ $t('qualitycheck.product.productparent') }}</strong></td>
              <td>
                <span></span>
                <span  v-if="item['productParent']"><router-link class="routerLink" :to="{ name: 'ProductShow', params: { id:  item['productParent']['@id']}  }">{{ item['productParent'].name }}</router-link></span>

              </td>
              <td></td>
              <td>

              </td>
            </tr>
            <tr >
              <td><strong>{{ $t('contract.contracts') }}</strong></td>
              <td>
                <ul v-for="(object, attr) in item['contracts']" :key="attr">
                  <li>
                    <span ><router-link class="routerLink" :to="{ name: 'ContractShow', params: { id:  object['@id']}  }">{{ object.name }}</router-link></span>
                  </li>
                </ul>
              </td>
              <td></td>
              <td>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.product.delivery') }}</strong></td>
              <td>
                {{ formatDateTime(item['delivery'], 'long') }}
              </td>
              <td><strong>{{ $t('qualitycheck.product.reforderfab') }}</strong></td>
              <td>
                {{ item['refOrderFab'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('qualitycheck.product.userassembly') }}</strong></td>
              <td>
                                  <span v-if="item['userAssembly']">  {{ item['userAssembly'].login }} </span>
              </td>
              <td><strong>{{ $t('qualitycheck.product.customerloan') }}</strong></td>
              <td>
                                  <span v-if="item['customerLoan']">  {{ item['customerLoan'].name }} </span>
              </td>
            </tr>

            <tr>

              <td><strong>{{ $t('qualitycheck.product.startassembly') }}</strong></td>
              <td>
                {{ formatDateTime(item['startAssembly'], 'long') }}              </td>

                <td><strong>{{ $t('qualitycheck.product.endassembly') }}</strong></td>
                <td>
                  {{ formatDateTime(item['endAssembly'], 'long') }}              </td>
            </tr>

            <tr>

            <td><strong>{{ $t('qualitycheck.product.link') }}</strong></td>
            <td>
              <a :href="item['link']">{{ item['link' ]}}</a>              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
  <v-row>
    <v-col md="6">
      <template>
        <div class="qualitycheck-list">
          <v-toolbar class="my-md-auto" elevation="0"  >
            <slot name="left"></slot>
            <v-spacer />
            <div v-if="userHasAccess('qualitycheck_edit')">
              <v-btn color="primary" rounded @click="addHandlerSub('QualityCheck',item)">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </div>
          </v-toolbar>

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1><v-icon large>mdi-bug-check</v-icon>{{$t('qualitycheck.qualitycheck.checks')}}</h1>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <QualityCheckFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>
                <br />
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="item.allQualityChecks"
                  :items-per-page.sync="options.itemsPerPage"
                  :footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
                  @click:row="showHandlerSub"
                  @contextmenu:row="showHandlerSubExt"
                >
                      <template slot="item.start" slot-scope="{ item }">
                        {{ formatDate(item['start'], 'long') }}
                      </template>
                      <template slot="item.end" slot-scope="{ item }">
                        {{ formatDate(item['end'], 'long') }}
                      </template>

                  <ActionCell
                    slot="item.action"
                    slot-scope="props"
                    :handle-show="() => showHandlerSub(item,'QualityCheck',props.item)"
                  ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
      </v-col>
      <v-col md="6">
        <ProductDataList
          ref="ProductDataList"
          :product="item"
        />

      </v-col>
      </v-row>
      <v-row>
      <v-col md="6">
        <TicketListProduct
          ref="TicketListProduct"
          :productParent="item"
        />
      </v-col>
      </v-row>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import DataFilter from '../../components/DataFilter';
import QualityCheckFilterForm from '../../components/qualitycheck/Filter';
import ProductDataList from '../productdata/List';
import TicketListProduct from '../ticket/ListProduct';
import ImageView from '../../components/ImageView.vue';

const servicePrefix = 'Product';

export default {
  name: 'ProductShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ActionCell,
      DataFilter,
      QualityCheckFilterForm,
      ImageView,
      ProductDataList,
      TicketListProduct
  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.product.product'), value: 'product.name' },
        { text: this.$t('qualitycheck.qualitycheck.name'), value: 'name' },
        { text: this.$t('qualitycheck.qualitycheck.comment'), value: 'comment' },
        { text: this.$t('qualitycheck.qualitycheck.usertesting'), value: 'userTesting.nom' },
        { text: this.$t('qualitycheck.qualitycheck.start'), value: 'start' },
        { text: this.$t('qualitycheck.qualitycheck.success'), value: 'success' },

        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'product' : this.$route.params.id,
      },
      selected: [],
    };
  },
  mixins: [ShowMixin,AccessMixin,ListMixin],
  mounted() {

  },
  computed: {
    ...mapFields('product', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('product', ['find']),
    ...mapGetters('qualitycheck', {
      items: 'list'
    }),
    ...mapFields('qualitycheck', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('product', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('qualitycheck', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
  }
};
</script>
